
























































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { Notify, Dialog } from "vant";
import NewExercises from "@/components/modals/NewExercise.vue";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {
    NewExercises,
  },
})
export default class ExerciseList extends Vue {
  ConvId: any;
  chap: any;
  exerciseId = -1;
  exercises: any = null;
  show = false;
  apiEndpoint = "";
  apiForNewExercise = "";
  apiForDeleteExercise = "";
  Category = "";
  @Prop() CategoryId!: any;
  MouseHover(exerciseId: any) {
    this.exerciseId = exerciseId;
  }
  MouseLeave(exerciseId: any) {
    this.exerciseId = -1;
  }

  get currentName() {
    return this.$route.name;
  }
  getImgUrl(item: any) {
    return item.imageUrl;
  }
  async DeleteExercise(id: string, index: string) {
    // location.reload();
    if (this.Category == "word") {
      this.apiForDeleteExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/DeleteWordExercise";
    } else if (this.Category == "grammar") {
      this.apiForDeleteExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/grammar/GrammarService/DeleteGrammarExercise";
    } else if (this.Category == "podcast") {
      this.apiForDeleteExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/podcast/PodcastService/DeletePodcastExercise";
    }
    Dialog.confirm({
      title: "Delete",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        let PassData: any;
        if (this.Category == "podcast") {
          PassData = { podcast_id: this.CategoryId, exercise_id: id };
        } else {
          PassData = { category_id: this.CategoryId, exercise_id: id };
        }
        const response = axios
          .post(this.apiForDeleteExercise, PassData)
          .then()
          .catch((error) => {
            Notify({ type: "danger", message: "Exercise is not deleted" });
          });
        this.$delete(this.exercises, index);
        Notify({ type: "success", message: "Exercise deleted" });
      })
      .catch(() => {
        // on cancel
      });
  }
  async mounted() {
    const categoryID = { category_id: this.CategoryId };
    if (this.$route.name == "main.conversation") {
      this.Category = "conversation";
      this.apiEndpoint =
        "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/GetConversationExerciseList";
    } else if (this.$route.name == "main.words_level") {
      this.Category = "word";
      this.apiEndpoint =
        "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/GetWordExerciseList";
    } else if (this.$route.name == "main.grammar") {
      this.Category = "grammar";
      this.apiEndpoint =
        "https://api.englishjanala.com:8443/v1/englishjanala/grammar/GrammarService/GetGrammarExerciseList";
    } else {
      this.Category = "podcast";
      this.apiEndpoint =
        "https://api.englishjanala.com:8443/v1/englishjanala/podcast/PodcastService/GetPodcastExerciseList";
    }
    console.warn("category ", this.Category);

    const podcastId = { podcast_id: this.CategoryId };
    let response: any;
    if (this.Category == "podcast") {
      response = await axios.post(this.apiEndpoint, podcastId);
    } else {
      response = await axios.post(this.apiEndpoint, categoryID);
    }

    const data = response.data;
    this.exercises = data.exercises;
    console.log(this.Category, data.exercises);
    console.log("res data", response.data);
  }

  NewExercise(exercise: any) {
    alert("new");
    console.warn(this.exercises.length);
    const exercise_id = "exercise" + (this.exercises.length + 1);
    this.exercises.push({
      name: exercise.name,
      id: exercise_id,
      numberQuestionsSelected: exercise.numberQuestionsSelected,
      description: exercise.description,
      shortDescription: exercise.shortDescription,
    });
    let RequestedData: any;
    if (this.Category == "podcast") {
      RequestedData = {
        podcast_id: this.CategoryId,
        exercise: {
          name: exercise.name,
          id: exercise_id,
          numberQuestionsSelected: exercise.numberQuestionsSelected,
          description: exercise.description,
          shortDescription: exercise.shortDescription,
        },
      };
    } else {
      RequestedData = {
        category_id: this.CategoryId,
        exercise: {
          name: exercise.name,
          id: exercise_id,
          numberQuestionsSelected: exercise.numberQuestionsSelected,
          description: exercise.description,
          shortDescription: exercise.shortDescription,
        },
      };
    }

    if (this.Category == "word") {
      // alert(this.Category);
      this.apiForNewExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/AddWordExercise";
    } else if (this.Category == "conversation") {
      this.apiForNewExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/AddConversationExercise";
    } else if (this.Category == "grammar") {
      this.apiForNewExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/grammar/GrammarService/AddGrammarExercise";
    } else if (this.Category == "podcast") {
      this.apiForNewExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/podcast/PodcastService/AddPodcastExercise";
    }

    const response = axios
      .post(this.apiForNewExercise, RequestedData)
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Excersice is not added" });
      });

    // const response = axios
    //   .post(
    //     "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/AddConversationExercise",
    //     RequestedData
    //   )
    //   .then()
    //   .catch((error) => {
    //     Notify({ type: "danger", message: "Excersice is not added" });
    //   });
    Notify({ type: "success", message: "Excersice added" });
    // chapter.name = chapter.id = chapter.imageUrl = chapter.contributorName = "";
    window.scrollTo(0, document.body.scrollHeight);
  }
}
